import { signIn, SignInInput } from "aws-amplify/auth";
import {
  Authenticator,
  View,
  Text,
  useTheme,
  Button,
  WithAuthenticatorProps,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import { PropsWithChildren, useEffect } from "react";
import "@aws-amplify/ui-react/styles.css";
import LogoText from "../components/LogoText";
import { useConfig } from "../containers/ConfigContext";

const components = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <LogoText />
      </View>
    );
  },

  SignIn: {
    Footer() {
      const { toForgotPassword } = useAuthenticator();
      return (
        <View style={{ padding: "0 1rem 1.5rem 1rem" }} textAlign="center">
          <Button
            fontWeight="normal"
            onClick={toForgotPassword}
            size="small"
            variation="link"
          >
            Forgot your Password?
          </Button>
        </View>
      );
    },
  },

  Footer() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={`${tokens.colors.neutral["80"]}`}>
          &copy; Alfacx All Rights Reserved
        </Text>
      </View>
    );
  },
};

const services = {
  async handleSignIn(formData: SignInInput) {
    let { username, password } = formData;
    return signIn({
      username,
      password,
    });
  },
};

export default function AuthenticatedPages(props: PropsWithChildren) {
  const { loggedUser } = useConfig();

  useEffect(() => {
    const chart = (window as any).ChartMessage;
    if (loggedUser && chart) {
      chart.postMessage(JSON.stringify({ logged: true }));
    }
  }, [loggedUser]);

  return (
    <Authenticator
      services={services}
      formFields={{
        signIn: {
          username: {
            placeholder: "Enter your Email or Username",
            isRequired: true,
            label: "Account",
          },
        },
        signUp: {
          username: {
            placeholder: "Enter your Email",
            type: "email",
            isRequired: true,
            label: "Email",
          },
        },
      }}
      loginMechanisms={["username"]}
      components={components}
      hideSignUp
    >
      {({ user }: WithAuthenticatorProps) => {
        return loggedUser ? <>{props.children}</> : <></>;
      }}
    </Authenticator>
  );
}
